import { inject, Injectable } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { TextDeliverableService } from '../shared/text-deliverable/text-deliverable.service';
import { TalkingPointComponent } from './talking-point.component';

@Injectable({
  providedIn: 'root',
})
export class TalkingPointService {
  private readonly textDeliverableService = inject(TextDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.textDeliverableService.getConfig({
      component: TalkingPointComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.talkingPointsDeliverable.title',
      deliverableType: EDeliverableType.talkingPoint,
    });
  }
}
